/*
 * @Author: cxy
 * @Desc:
 * @Date: 2023-12-23 14:57:12
 * @LastEditTime: 2024-05-23 11:14:24
 */
import Vue from 'vue'
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')

Vue.filter('NumberFormat', function (value) {
  if (!value) {
    return '0'
  }
  const intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
  return intPartFormat
})

Vue.filter('dayjs', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return dataStr ? dataStr.toString().length === 10 ? moment(dataStr * 1000).format(pattern) : moment(dataStr).format(pattern) : '--'
})

Vue.filter('moment', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

Vue.filter('formatDate', function (value, pattern = 'YYYY-MM-DD HH:mm:ss', placeholder = '/') {
  if (value === '0') return placeholder
  return value && moment.unix(Number(value)).format(pattern)
})

Vue.filter('filterNumber', function (value, decimals = 2) {
  value = Number(value)
  if (isNaN(value) || !value) return '0.00'
  return value.toFixed(decimals).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
})
